import actionTypes from './actionTypes';
import type { IBlockedRemoval, IScopeCombinationsResponse, ParsedErrorMap } from '../sharedTypes';
import type { ILoadCombinationsPayload, ISubmitRequestPayload, ISubmitResult } from './types';

const actions = {
  loadCombinationsRequest: (payload: ILoadCombinationsPayload) => ({
    type: actionTypes.LOAD_COMBINATIONS_REQUEST,
    payload,
  }),
  loadCombinationsSuccess: (response: IScopeCombinationsResponse) => ({
    type: actionTypes.LOAD_COMBINATIONS_SUCCESS,
    payload: { response },
  }),
  loadCombinationsError: () => ({ type: actionTypes.LOAD_COMBINATIONS_ERROR }),
  clearCombinations: () => ({ type: actionTypes.CLEAR_COMBINATIONS }),
  submitRequest: (payload: ISubmitRequestPayload) => ({ type: actionTypes.SUBMIT_REQUEST, payload }),
  submitSuccess: (result: ISubmitResult) => ({ type: actionTypes.SUBMIT_SUCCESS, payload: { result } }),
  submitFailed: (parsedErrors: ParsedErrorMap, blockedRemovals: IBlockedRemoval[] = []) => ({
    type: actionTypes.SUBMIT_FAILED,
    payload: { parsedErrors, blockedRemovals },
  }),
  clearSubmitErrors: () => ({ type: actionTypes.CLEAR_SUBMIT_ERRORS }),
  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
